// Shqip — tekstet ligjore dhe të mbështetjes.
export default (C) => ({
  ui: {
    header: "LIGJORE & MBËSHTETJE",
    back: "KTHEHU",
    nav: "Dokumentet ligjore",
    onThisPage: "NË KËTË FAQE",
    lastUpdated: "PËRDITËSUAR MË",
    effective: "29 tetor 2026",
    companyDetails: "TË DHËNAT E SHOQËRISË",
    cd: { company: "Shoqëria", nipt: "NIPT", office: "Selia e regjistruar & pika e shërbimit", email: "E-mail", phone: "Telefon" },
  },

  privacy: {
    kicker: "LIGJORE · PRIVATËSIA",
    title: "Politika e privatësisë",
    intro: "Si i trajton Eagle Inc të dhënat tuaja personale — në faqet tona të internetit, në shërbimet tona dhe kur na paguani me kartë, Apple Pay, Google Pay, lidhje pagese ose kod QR.",
    sections: [
      {
        id: "who-we-are",
        title: "Kush jemi",
        body: [
          `Kjo politikë privatësie shpjegon si ${C.legalName} ("Eagle Inc", "ne") mbledh, përdor dhe mbron të dhënat personale kur vizitoni një nga faqet tona të internetit, na kontaktoni, merrni një faturë ose na paguani me kartë, Apple Pay, Google Pay, lidhje pagese ose kod QR.`,
          "Ajo zbatohet për të gjitha faqet e internetit të grupit Eagle Inc, përfshirë eagle-inc.net, eagle-inc.al, eagle-inc.eu, eagle-eyes.al, eagle-commerce.al, digital-services.al, socialdeal.al, bookitnow.al dhe incontact.al, si dhe për shërbimet e ofruara nën markat Eagle Eyes (Real Estate, IT Management, Digital Services) dhe Eagle Commerce.",
          {
            kv: [
              ["Kontrolluesi", C.legalName],
              ["Emrat tregtarë", C.tradeNames],
              ["NIPT", C.nuis],
              ["Adresa e regjistruar", C.address],
              ["Kontakti për privatësinë", C.supportEmail],
              ["Telefon", C.supportPhone],
            ],
          },
        ],
      },
      {
        id: "legal-framework",
        title: "Korniza ligjore",
        body: [
          "Ne i përpunojmë të dhënat personale në përputhje me Ligjin nr. 124/2024 \"Për mbrojtjen e të dhënave personale\". Nëse ndodheni në Bashkimin Evropian ose në Zonën Ekonomike Evropiane dhe për përpunimin tonë zbatohet Rregullorja e Përgjithshme për Mbrojtjen e të Dhënave (GDPR, Rregullorja (BE) 2016/679), ne respektojmë edhe GDPR-në.",
          "Autoriteti mbikëqyrës në Shqipëri është Komisioneri për të Drejtën e Informimit dhe Mbrojtjen e të Dhënave Personale, https://idp.al.",
        ],
      },
      {
        id: "data-we-collect",
        title: "Të dhënat personale që mbledhim",
        body: [
          "Mbledhim vetëm të dhënat që na nevojiten për qëllimet e përshkruara më poshtë:",
          {
            list: [
              "Të dhëna identifikimi dhe kontakti — emri, emri i shoqërisë, adresa e e-mailit, numri i telefonit dhe adresa postare ose e faturimit, që na i jepni përmes formularëve tanë të kontaktit dhe mbështetjes, me e-mail, telefon ose WhatsApp, ose kur përgatisim një ofertë, kontratë ose faturë.",
              "Të dhëna kontraktuale dhe faturimi — shërbimet e porositura, ofertat, kontratat, faturat, numrat e faturave, shumat, monedha, të dhënat e TVSH-së dhe korrespondenca për angazhimin.",
              "Të dhëna të transaksioneve të pagesës — statusi i pagesës, data, shuma, monedha, lloji i mjetit të pagesës (p.sh. Visa, Mastercard, Apple Pay, Google Pay), një referencë autorizimi ose transaksioni dhe, kur e jep banka, një numër karte i maskuar (p.sh. katër shifrat e fundit). Ne nuk marrim dhe nuk ruajmë kurrë numra të plotë kartash, data skadimi ose kode CVV/CVC.",
              "Të dhëna të mbështetjes — përmbajtja e kërkesave tuaja për mbështetje dhe rimbursim, si dhe çdo informacion që zgjidhni të ndani me ne kur ju ndihmojmë.",
              "Të dhëna teknike — adresa IP, lloji i shfletuesit, informacioni i pajisjes dhe regjistrat e kërkesave që infrastruktura jonë e strehimit regjistron automatikisht për sigurinë dhe për ofrimin e faqes.",
            ],
          },
          "Ne nuk mbledhim me dijeni kategori të veçanta të dhënash personale dhe ju kërkojmë të mos na i dërgoni të tilla të dhëna.",
        ],
      },
      {
        id: "card-payments",
        title: "Pagesat me kartë, Apple Pay dhe Google Pay",
        body: [
          "Pagesat me kartë përpunohen nga banka jonë pranuese, Raiffeisen Bank Sh.A. (Shqipëri), përmes shërbimit të saj të tregtisë elektronike RaiAccept. Kur paguani përmes një lidhjeje pagese ose kodi QR të RaiAccept, të dhënat e kartës — ose autorizimin e Apple Pay apo Google Pay — i jepni në faqen e sigurt të pagesës së bankës, jo në faqen tonë.",
          {
            list: [
              "Të dhënat e kartës suaj transmetohen të enkriptuara (TLS) drejtpërdrejt te banka dhe infrastruktura e saj e pagesave në përputhje me PCI DSS. Eagle Inc nuk e sheh, nuk e përpunon dhe nuk e ruan numrin e plotë të kartës ose kodin e sigurisë.",
              "Pagesat mund të verifikohen nga lëshuesi i kartës suaj me 3-D Secure (p.sh. Visa Secure, Mastercard Identity Check).",
              "Nëse përdorni Apple Pay ose Google Pay, Apple ose Google i përpunojnë të dhënat tuaja sipas politikave të tyre të privatësisë; banka merr një numër karte të tokenizuar, jo numrin e vërtetë të kartës suaj.",
              "Raiffeisen Bank, skemat e kartave (Visa, Mastercard) dhe lëshuesi i kartës suaj veprojnë si kontrollues të pavarur për të dhënat që përpunojnë për të kryer, siguruar dhe shlyer pagesën dhe për të parandaluar mashtrimin.",
              "Nga banka marrim vetëm informacionin e nevojshëm për ta lidhur pagesën me faturën tuaj dhe për të trajtuar rimbursimet dhe mosmarrëveshjet (shih \"Të dhënat personale që mbledhim\").",
            ],
          },
        ],
      },
      {
        id: "purposes",
        title: "Pse i përdorim të dhënat tuaja dhe baza ligjore",
        body: [
          {
            kv: [
              ["Përgjigja ndaj pyetjeve tuaja", "Hapa të ndërmarrë me kërkesën tuaj para lidhjes së kontratës; interesi ynë i ligjshëm për t'iu përgjigjur mesazheve."],
              ["Oferta, kontrata dhe ofrimi i shërbimeve", "Zbatimi i një kontrate me ju."],
              ["Faturimi dhe arkëtimi i pagesave", "Zbatimi i një kontrate; detyrim ligjor (legjislacioni kontabël dhe tatimor)."],
              ["Rimbursime, chargeback dhe mosmarrëveshje pagesash", "Zbatimi i një kontrate; detyrim ligjor; interes i ligjshëm për mbrojtjen e pretendimeve ligjore."],
              ["Mbështetja e klientit", "Zbatimi i një kontrate; interes i ligjshëm për të ofruar shërbim të mirë."],
              ["Parandalimi i mashtrimit dhe siguria e faqes", "Interes i ligjshëm për të mbrojtur klientët, biznesin dhe sistemet tona; detyrim ligjor kur zbatohet."],
              ["Regjistrat kontabël, tatimorë dhe rregullatorë", "Detyrim ligjor."],
              ["Ruajtja e zgjedhjes së gjuhës", "Interes i ligjshëm për një faqe funksionale (ruhet vetëm në shfletuesin tuaj)."],
            ],
          },
          "Ne nuk shesim të dhëna personale, nuk i përdorim për vendimmarrje të automatizuar me pasoja ligjore ose pasoja të ngjashme të rëndësishme për ju dhe dërgojmë mesazhe marketingu vetëm nëse i keni kërkuar. Mund të çregjistroheni në çdo kohë.",
        ],
      },
      {
        id: "recipients",
        title: "Me kë i ndajmë të dhënat",
        body: [
          "Të dhënat personale i ndajmë vetëm kur është e nevojshme, me:",
          {
            list: [
              "Raiffeisen Bank Sh.A. (Shqipëri) dhe skemat e kartave e rrjetet e pagesave të përfshira në përpunimin e pagesës suaj, si dhe Apple ose Google kur përdorni portofolin e tyre.",
              "Microsoft (strehimi Microsoft Azure dhe shërbimet e e-mailit e produktivitetit Microsoft 365) — si përpunuesi ynë.",
              "MongoDB Inc. (strehimi i bazës së të dhënave MongoDB Atlas për formularët e dërguar nga faqja) — si përpunuesi ynë.",
              "GitHub (strehimi i kodit burimor dhe procesi i ndërtimit; aty nuk ruhen të dhëna klientësh).",
              "Kontabilistët, audituesit dhe këshilltarët tanë ligjorë, të detyruar për konfidencialitet.",
              "Autoritetet publike, gjykatat dhe organet e zbatimit të ligjit kur jemi të detyruar me ligj.",
            ],
          },
          "Çdo përpunues është i lidhur me një marrëveshje me shkrim dhe mund t'i përdorë të dhënat tuaja vetëm sipas udhëzimeve tona.",
        ],
      },
      {
        id: "transfers",
        title: "Transferimet ndërkombëtare",
        body: [
          "Disa nga ofruesit tanë të shërbimeve (si Microsoft dhe MongoDB) mund të përpunojnë të dhëna në Bashkimin Evropian ose në vende të tjera jashtë Shqipërisë. Kur të dhënat transferohen në një vend që nuk ofron nivel të përshtatshëm mbrojtjeje, mbështetemi në garancitë e përshtatshme të parashikuara nga Ligji nr. 124/2024 dhe, kur zbatohet, nga GDPR — si klauzolat standarde kontraktuale — si dhe në angazhimet e vetë ofruesve për sigurinë.",
        ],
      },
      {
        id: "retention",
        title: "Sa kohë i ruajmë të dhënat",
        body: [
          {
            list: [
              "Pyetjet dhe kërkesat për mbështetje që nuk çojnë në kontratë: deri në 24 muaj pas kontaktit të fundit.",
              "Kontratat, faturat, regjistrat e pagesave dhe ata kontabël: për periudhën që kërkon legjislacioni shqiptar kontabël dhe tatimor.",
              "Të dhënat e nevojshme për një mosmarrëveshje, rimbursim ose chargeback: derisa çështja të zgjidhet plotësisht dhe të ketë kaluar çdo afat parashkrimi përkatës.",
              "Të dhënat teknike të regjistrave: si rregull jo më shumë se 90 ditë, përveç rasteve kur nevojiten për hetimin e një incidenti sigurie.",
            ],
          },
          "Pas këtyre afateve, të dhënat fshihen ose anonimizohen.",
        ],
      },
      {
        id: "cookies",
        title: "Cookies dhe ruajtja lokale",
        body: [
          "Faqet tona nuk përdorin cookies reklamuese ose gjurmuese. Ruajmë vetëm një element në hapësirën lokale të shfletuesit tuaj — gjuhën e zgjedhur të shfaqjes — që faqja ta mbajë mend. Ky element nuk largohet kurrë nga pajisja juaj dhe mund ta fshini në çdo kohë nga cilësimet e shfletuesit.",
          "Për të shfaqur shkronjat tona, shfletuesi juaj ngarkon fonte nga Google Fonts dhe Fontshare, të cilët marrin adresën tuaj IP si pjesë e kësaj kërkese teknike. Faqja e pagesës RaiAccept, e administruar nga banka, mund të përdorë cookies të veta rreptësisht të nevojshme për sigurinë dhe parandalimin e mashtrimit.",
        ],
      },
      {
        id: "security",
        title: "Si i mbrojmë të dhënat tuaja",
        body: [
          "Të gjitha faqet tona ofrohen vetëm përmes HTTPS. Të dhënat ruhen te ofrues të besueshëm cloud, qasja kufizohet te persona të autorizuar me vërtetim shumëfaktorësh dhe zbatojmë parimin e privilegjit minimal. Të dhënat e kartave nuk arrijnë kurrë në sistemet tona.",
          "Nëse ndodh një cenim i të dhënave personale që ka gjasa të paraqesë rrezik për të drejtat tuaja, do ta njoftojmë Komisionerin brenda 72 orëve dhe do t'ju informojmë pa vonesë të panevojshme kur rreziku është i lartë, siç kërkon ligji.",
        ],
      },
      {
        id: "your-rights",
        title: "Të drejtat tuaja",
        body: [
          "Sipas kushteve të ligjit, keni të drejtë:",
          {
            list: [
              "të informoheni dhe të keni qasje në të dhënat personale që mbajmë për ju;",
              "të korrigjohen të dhënat e pasakta dhe të plotësohen ato të paplota;",
              "të fshihen të dhënat tuaja (\"e drejta për t'u harruar\");",
              "të kufizohet përpunimi i të dhënave tuaja;",
              "të merrni të dhënat tuaja në një format të strukturuar dhe të lexueshëm nga makina (transportueshmëria e të dhënave);",
              "të kundërshtoni përpunimin e bazuar në interesat tona të ligjshme dhe, në çdo kohë, marketingun e drejtpërdrejtë;",
              "të tërhiqni pëlqimin e dhënë, pa ndikuar në përpunimin e mëparshëm.",
            ],
          },
          `Për të ushtruar të drejtat tuaja, shkruani në ${C.supportEmail} ose me postë te ${C.legalName}, ${C.address}. Mund t'ju kërkojmë të verifikoni identitetin dhe do të përgjigjemi brenda afateve ligjore (zakonisht brenda një muaji).`,
          "Keni gjithashtu të drejtë të paraqisni ankesë te Komisioneri për të Drejtën e Informimit dhe Mbrojtjen e të Dhënave Personale (https://idp.al) ose, në BE/ZEE, tek autoriteti i mbrojtjes së të dhënave në vendin tuaj të banimit.",
        ],
      },
      {
        id: "children",
        title: "Fëmijët",
        body: ["Shërbimet tona u drejtohen bizneseve dhe të rriturve. Ne nuk mbledhim me dijeni të dhëna personale të fëmijëve nën 16 vjeç."],
      },
      {
        id: "changes",
        title: "Ndryshimet në këtë politikë",
        body: [
          "Mund ta përditësojmë herë pas here këtë politikë privatësie. Versioni në fuqi është gjithmonë i disponueshëm në /privacy, me datën e përditësimit të fundit në krye të faqes. Ndryshimet thelbësore u njoftohen klientëve ekzistues me e-mail.",
        ],
      },
      {
        id: "contact",
        title: "Kontakti",
        body: [
          { kv: [["Shoqëria", C.legalName], ["Adresa", C.address], ["E-mail", C.supportEmail], ["Telefon", C.supportPhone], ["Mbështetje", "/support"]] },
        ],
      },
    ],
  },

  terms: {
    kicker: "LIGJORE · KUSHTET E PËRDORIMIT",
    title: "Kushtet e përdorimit",
    intro: "Kushtet që zbatohen për faqet tona të internetit, shërbimet tona dhe pagesat ndaj Eagle Inc me kartë, Apple Pay, Google Pay, lidhje pagese ose kod QR — përfshirë politikën tonë të anulimit dhe rimbursimit.",
    sections: [
      {
        id: "merchant",
        title: "Informacioni i tregtarit",
        body: [
          "Këto Kushte përdorimi rregullojnë përdorimin e faqeve të internetit të grupit Eagle Inc dhe blerjen e pagesën e shërbimeve tona. Tregtari dhe shitësi për të gjitha pagesat është:",
          {
            kv: [
              ["Tregtari", C.legalName],
              ["Emrat tregtarë", C.tradeNames],
              ["NIPT", C.nuis],
              ["Adresa e regjistruar", C.address],
              ["Vendi", "Shqipëri"],
              ["Mbështetja e klientit", `${C.supportEmail} · ${C.supportPhone}`],
              ["Faqja e mbështetjes", C.supportUrl],
            ],
          },
          "Duke përdorur faqet tona, duke pranuar një ofertë ose duke paguar një faturë, lidhje pagese ose kod QR të lëshuar nga ne, ju pranoni këto Kushte. Nëse nuk jeni dakord, ju lutemi mos i përdorni faqet ose shërbimet tona.",
        ],
      },
      {
        id: "services",
        title: "Shërbimet tona",
        body: [
          "Eagle Inc ofron shërbime profesionale nën markat e saj, përfshirë menaxhimin e IT-së dhe konsulencën IT (cloud, infrastrukturë, Microsoft 365/Azure, menaxhim portofoli), shërbime dixhitale dhe produkte softuerike, si dhe shërbime për pasuri të paluajtshme banimi në Tiranë.",
          "Shërbimet tona janë jomateriale: nuk ka dërgesë fizike. Fusha e saktë, produktet e dorëzueshme, kriteret e pranimit, afatet dhe çmimi i çdo angazhimi përcaktohen në ofertën, propozimin, kontratën ose faturën me shkrim që ju lëshojmë (\"Porosia\"). Nëse një Porosi bie ndesh me këto Kushte, mbizotëron Porosia.",
        ],
      },
      {
        id: "orders",
        title: "Ofertat, porositë dhe kontrata",
        body: [
          {
            list: [
              "Kontrata lidhet kur pranoni ofertën ose propozimin tonë me shkrim (me e-mail, me nënshkrim ose duke paguar faturën ose lidhjen e pagesës përkatëse).",
              "Ofertat janë të vlefshme për 30 ditë, përveç rasteve kur shënohet ndryshe.",
              "Shërbimet dhe zgjidhjet e njëhershme faturohen në fillim të angazhimit, përveç rasteve kur Porosia parashikon ndryshe.",
              "Shërbimet e vazhdueshme (si IT e menaxhuar dhe menaxhimi i portofolit) ofrohen me kontratë vjetore me faturim mujor, siç përcaktohet në Porosi.",
              "Ju jeni përgjegjës për dhënien e informacionit të saktë, qasjen në kohë në sisteme dhe bashkëpunimin që na nevojitet në mënyrë të arsyeshme për të ofruar shërbimin.",
            ],
          },
        ],
      },
      {
        id: "prices",
        title: "Çmimet dhe monedha",
        body: [
          "Çmimet tregohen në Porosi dhe në faturë ose në lidhjen e pagesës, në lekë shqiptarë (ALL) ose euro (EUR). Shuma dhe monedha që shfaqen në faqen e pagesës RaiAccept janë shuma dhe monedha që do t'ju tarifohen.",
          "Përveç kur shënohet shprehimisht ndryshe, çmimet nuk përfshijnë TVSH-në, e cila shtohet kur e kërkon legjislacioni tatimor shqiptar. Nëse karta juaj është në një monedhë tjetër, lëshuesi i kartës mund të zbatojë kursin e vet të këmbimit dhe tarifat e veta; Eagle Inc nuk ka kontroll mbi to.",
        ],
      },
      {
        id: "payment",
        title: "Mënyrat e pagesës dhe siguria e pagesave",
        body: [
          "Pranojmë mënyrat e mëposhtme të pagesës:",
          {
            list: [
              "karta krediti dhe debiti Visa dhe Mastercard;",
              "Apple Pay dhe Google Pay, kur mbështeten nga pajisja dhe karta juaj;",
              "lidhje pagese dhe kode QR të krijuara përmes RaiAccept dhe të përfshira në faturat tona ose të dërguara me e-mail apo mesazh;",
              "transfertë bankare në llogarinë e shënuar në faturë.",
            ],
          },
          "Pagesat me kartë, Apple Pay dhe Google Pay përpunohen nga banka jonë pranuese, Raiffeisen Bank Sh.A. (Shqipëri), përmes shërbimit të saj të tregtisë elektronike RaiAccept. Të dhënat e kartës vendosen vetëm në faqen e sigurt të pagesës së bankës, në përputhje me PCI DSS, përmes një lidhjeje të enkriptuar (TLS). Eagle Inc nuk e sheh dhe nuk e ruan kurrë numrin e plotë të kartës suaj, datën e skadimit ose kodin e sigurisë. Pagesat mund të kërkojnë vërtetim 3-D Secure nga lëshuesi i kartës suaj.",
          "Çdo lidhje pagese ose kod QR lidhet me një faturë dhe shumë të caktuar. Para se të paguani, kontrolloni gjithmonë që emri i tregtarit në faqen e pagesës të jetë \"Eagle Inc\". Nëse një lidhje ka skaduar ose nuk funksionon, kontaktoni mbështetjen dhe do t'ju dërgojmë një të re.",
          "Pagesa duhet të kryhet në datën e shënuar në faturë. Mund të pezullojmë shërbimet e vazhdueshme nëse një faturë mbetet e papaguar pas një kujtese me shkrim.",
          { note: `Eagle Inc nuk do t'ju kërkojë kurrë të dërgoni numrin e plotë të kartës, datën e skadimit ose kodin e sigurisë me e-mail, telefon, chat ose ndonjë kanal tjetër. Nëse merrni një kërkesë të tillë në emrin tonë, mos u përgjigjni dhe raportojeni në ${C.supportEmail}.` },
        ],
      },
      {
        id: "delivery",
        title: "Ofrimi i shërbimeve",
        body: [
          "Shërbimet ofrohen në distancë dhe/ose në vend, siç përshkruhet në Porosi. Ofrimi fillon në datën e rënë dakord ose pas marrjes së pagesës kur kërkohet pagesë paraprake. Produktet e dorëzueshme (si raporte, konfigurime, dokumentacion ose qasje në softuer) dorëzohen në mënyrë elektronike ose në vend. Do të merrni një konfirmim me e-mail kur një shërbim i paguar është ofruar ose kur është përmbushur një fazë.",
        ],
      },
      {
        id: "cancellation",
        title: "Politika e anulimit dhe e rimbursimit",
        body: [
          {
            list: [
              "Para fillimit të punës: mund ta anuloni me shkrim një Porosi në çdo kohë para se të fillojmë ofrimin e shërbimit dhe merrni rimbursim të plotë të shumës së paguar.",
              "Pas fillimit të punës: mund të anuloni me shkrim; paguani punën e kryer dhe kostot e bëra deri në datën e anulimit, ndërsa çdo shumë e paguar paraprakisht për punë ende të pakryer rimbursohet.",
              "Kontratat vjetore me faturim mujor mund të ndërpriten siç parashikohet në kontratë. Muajt e faturuar dhe të ofruar nuk rimbursohen, përveç rasteve kur shërbimi nuk është ofruar.",
              "Tarifime të dyfishta ose të pasakta: nëse ju është tarifuar dy herë ose një shumë e pasaktë, e rimbursojmë plotësisht tepricën.",
              "Shërbime të pa ofruara sipas marrëveshjes: nëse nuk e ofrojmë një shërbim në përputhje me Porosinë dhe nuk mund ta ndreqim brenda një afati të arsyeshëm, keni të drejtë për rimbursim të plotë ose proporcional.",
            ],
          },
          `Si të kërkoni rimbursim: shkruani në ${C.supportEmail} ose përdorni formularin në /support, duke shënuar numrin e faturës, datën e pagesës, shumën dhe arsyen. E konfirmojmë marrjen brenda 1 dite pune dhe vendosim brenda 5 ditëve pune.`,
          "Rimbursimet e miratuara bëhen në të njëjtën kartë ose mjet pagese të përdorur për pagesën fillestare (përfshirë Apple Pay ose Google Pay) — nuk i rimbursojmë pagesat me kartë në para në dorë ose në një kartë tjetër. E nisim rimbursimin brenda 5 ditëve pune nga miratimi; në varësi të lëshuesit të kartës, mund të duhen deri në 10 ditë pune derisa shuma të shfaqet në pasqyrën tuaj.",
          "Kur veproni si konsumator, rregullat detyruese të mbrojtjes së konsumatorit të ligjit shqiptar, përfshirë çdo të drejtë ligjore tërheqjeje për kontratat në distancë, zbatohen përveç kësaj politike dhe nuk kufizohen prej saj.",
        ],
      },
      {
        id: "disputes",
        title: "Mosmarrëveshjet e pagesave dhe chargeback",
        body: [
          `Nëse nuk e njihni një tarifim nga Eagle Inc ose nuk jeni dakord me një shumë, ju lutemi na kontaktoni fillimisht në ${C.supportEmail} — shumica e rasteve zgjidhen shpejt dhe rimbursohen drejtpërdrejt. Kjo nuk cenon të drejtën tuaj për ta kundërshtuar një transaksion te lëshuesi i kartës. Nëse nis një chargeback, do të bashkëpunojmë me bankën dhe do të japim Porosinë, faturën dhe dokumentacionin e ofrimit përkatës.`,
        ],
      },
      {
        id: "website-use",
        title: "Përdorimi i faqeve tona",
        body: [
          "Faqet tona mund t'i përdorni vetëm për qëllime të ligjshme. Nuk lejohet të përpiqeni të fitoni qasje të paautorizuar në sistemet tona, të ndërhyni në funksionimin e faqeve, të jepni informacion të rremë ose të keqpërdorni formularët tanë. Mund ta ndryshojmë, pezullojmë ose ndërpresim çdo pjesë të faqeve në çdo kohë.",
          "E gjithë përmbajtja në faqet tona — përfshirë tekstet, logot, medaljonin Eagle, dizajnet, imazhet dhe softuerin — është pronë e Eagle Inc ose e licencuar asaj dhe mbrohet nga ligji i pronësisë intelektuale. Nuk lejohet ta kopjoni ose ripërdorni pa lejen tonë paraprake me shkrim.",
          "Informacioni në faqet tona është i përgjithshëm dhe mund të ndryshojë. Ai nuk përbën ofertë përveç kur konfirmohet në një Porosi. Lidhjet drejt faqeve të palëve të treta jepen për lehtësi; nuk jemi përgjegjës për përmbajtjen e tyre.",
        ],
      },
      {
        id: "liability",
        title: "Përgjegjësia",
        body: [
          "Shërbimet tona i kryejmë me kujdesin e duhur dhe sipas praktikës së mirë profesionale. Në masën e lejuar nga ligji, përgjegjësia jonë e përgjithshme që rrjedh nga një Porosi kufizohet në shumën që keni paguar sipas asaj Porosie në dymbëdhjetë muajt para ngjarjes që shkaktoi pretendimin, dhe nuk mbajmë përgjegjësi për dëme indirekte ose pasuese, përfshirë fitimin e humbur ose humbjen e të dhënave.",
          "Asgjë në këto Kushte nuk e përjashton ose kufizon përgjegjësinë që nuk mund të përjashtohet ose kufizohet sipas ligjit të zbatueshëm, përfshirë përgjegjësinë për dashje ose pakujdesi të rëndë, as të drejtat tuaja detyruese si konsumator.",
        ],
      },
      {
        id: "privacy",
        title: "Privatësia",
        body: ["Të dhënat personale i përpunojmë në përputhje me Politikën tonë të privatësisë, që gjendet në /privacy."],
      },
      {
        id: "force-majeure",
        title: "Forca madhore",
        body: ["Asnjëra palë nuk mban përgjegjësi për mospërmbushjen ose vonesën e shkaktuar nga ngjarje jashtë kontrollit të saj të arsyeshëm, si fatkeqësi natyrore, ndërprerje të energjisë ose të rrjetit te ofrues të palëve të treta, luftë, greva ose veprime të autoriteteve. Detyrimet pezullohen për kohëzgjatjen e një ngjarjeje të tillë."],
      },
      {
        id: "law",
        title: "Ligji i zbatueshëm dhe mosmarrëveshjet",
        body: [
          "Këto Kushte dhe çdo Porosi rregullohen nga ligjet e Republikës së Shqipërisë. Gjithmonë përpiqemi t'i zgjidhim ankesat fillimisht me mirëkuptim — ju lutemi kontaktoni mbështetjen. Mosmarrëveshjet që nuk mund të zgjidhen me mirëkuptim janë në juridiksionin e gjykatës kompetente në Tiranë, Shqipëri, pa cenuar të drejtën detyruese të konsumatorit për të ngritur padi në gjykatat e vendbanimit të tij.",
        ],
      },
      {
        id: "changes",
        title: "Ndryshimet në këto Kushte",
        body: [
          "Mund t'i ndryshojmë këto Kushte herë pas here. Për çdo Porosi zbatohet versioni i publikuar në /termsofuse në datën e Porosisë suaj. Data e përditësimit të fundit shfaqet në krye të kësaj faqeje.",
        ],
      },
    ],
  },

  support: {
    kicker: "MBËSHTETJA E KLIENTIT",
    title: "Mbështetje",
    intro: "Ndihmë për pagesat, faturat, rimbursimet dhe shërbimet tona. Ekipi ynë i mbështetjes i përgjigjet personalisht çdo kërkese.",
    tocContact: "Kontaktoni mbështetjen e klientit",
    tocRequest: "Dërgoni një kërkesë për mbështetje",
    email: "E-mail",
    phone: "Telefon",
    hoursLabel: "Orari i mbështetjes",
    hours: "E hënë – e premte, 09:00 – 17:00 (CET/CEST, ora e Tiranës). Përgjigja e parë brenda 1 dite pune.",
    security: "Për sigurinë tuaj, mos na dërgoni kurrë numrin e plotë të kartës, datën e skadimit ose kodin e sigurisë (CVV/CVC). Për të identifikuar një pagesë mjaftojnë numri i faturës, data, shuma dhe katër shifrat e fundit të kartës suaj.",
    requestTitle: "Dërgoni një kërkesë për mbështetje",
    faqTitle: "PYETJE TË SHPESHTA",
    topics: [
      "Problem me pagesën (e refuzuar, e dështuar, lidhje ose kod QR i skaduar)",
      "Kërkesë për rimbursim",
      "Tarifim i dyfishtë ose i pasaktë",
      "Pyetje për një faturë",
      "Pyetje për një shërbim ose porosi",
      "Privatësia / kërkesë për të dhënat personale",
      "Tjetër",
    ],
    form: {
      name: "Emri i plotë",
      email: "Adresa e e-mailit",
      reference: "Numri i faturës ose referenca (opsionale)",
      message: "Si mund t'ju ndihmojmë? Mos shkruani kurrë numrin e plotë të kartës ose kodin e sigurisë.",
      consent: "Duke dërguar këtë formular pranoni që t'i përpunojmë të dhënat tuaja për të trajtuar kërkesën, siç përshkruhet në /privacy.",
      send: "DËRGO KËRKESËN",
      sending: "DUKE U DËRGUAR…",
      sentTitle: "Faleminderit — kërkesa juaj u mor.",
      sentBody: (email) => `Do t'ju përgjigjemi brenda 1 dite pune në ${email}.`,
      error: `Mesazhi juaj nuk mund të dërgohej. Ju lutemi shkruani në ${C.supportEmail} ose telefononi në ${C.supportPhone}.`,
    },
    faq: [
      {
        id: "pay-how",
        title: "Si ta paguaj një faturë?",
        body: [
          "Çdo faturë përmban një lidhje pagese të sigurt RaiAccept dhe një kod QR nga Raiffeisen Bank Albania. Klikoni lidhjen ose skanoni kodin QR me kamerën e telefonit, kontrolloni shumën dhe që tregtari të jetë Eagle Inc, dhe paguani me Visa, Mastercard, Apple Pay ose Google Pay. Mund të paguani edhe me transfertë bankare në llogarinë e shënuar në faturë.",
        ],
      },
      {
        id: "pay-failed",
        title: "Pagesa ime u refuzua ose dështoi",
        body: [
          {
            list: [
              "Kontrolloni që të dhënat e kartës, data e skadimit dhe të dhënat e faturimit të jenë të sakta dhe që pagesat online/ndërkombëtare të jenë të aktivizuara në kartën tuaj.",
              "Përfundoni verifikimin 3-D Secure në aplikacionin e bankës ose me kodin SMS — pagesa dështon nëse ky hap skadon.",
              "Sigurohuni që karta të ketë gjendje ose limit të mjaftueshëm.",
              "Provoni Apple Pay ose Google Pay, një kartë tjetër, ose kontaktoni lëshuesin e kartës — refuzimet vendosen nga banka lëshuese, e cila mund t'ju tregojë arsyen.",
            ],
          },
          "Një pagesë e refuzuar nuk tarifohet. Nëse pas një përpjekjeje të dështuar në llogarinë tuaj shfaqet një shumë e rezervuar (në pritje), banka juaj e çliron automatikisht, zakonisht brenda pak ditësh pune.",
        ],
      },
      {
        id: "pay-link",
        title: "Lidhja e pagesës ose kodi QR ka skaduar ose nuk hapet",
        body: ["Lidhjet e pagesës dhe kodet QR janë të vlefshme për një kohë të kufizuar dhe për një shumë të caktuar. Na kontaktoni me numrin e faturës dhe do t'ju dërgojmë një lidhje të re brenda 1 dite pune."],
      },
      {
        id: "double",
        title: "Më është tarifuar dy herë ose një shumë e gabuar",
        body: ["Na kontaktoni me numrin e faturës, datën dhe shumën e çdo tarifimi dhe katër shifrat e fundit të kartës. Tarifimet e dyfishta ose të pasakta rimbursohen plotësisht në kartën fillestare."],
      },
      {
        id: "refund",
        title: "Si ta kërkoj një rimbursim?",
        body: [
          `Përdorni formularin më sipër ose shkruani në ${C.supportEmail} me numrin e faturës, datën e pagesës, shumën dhe arsyen e kërkesës. E konfirmojmë marrjen brenda 1 dite pune dhe vendosim brenda 5 ditëve pune. Rimbursimet e miratuara bëhen në të njëjtën kartë ose portofol të përdorur për pagesën dhe nisen brenda 5 ditëve pune; lëshuesit të kartës mund t'i duhen deri në 10 ditë pune që shuma të shfaqet në pasqyrën tuaj. Politika e plotë gjendet në Kushtet tona të përdorimit: /termsofuse.`,
        ],
      },
      {
        id: "receipt",
        title: "Ku e gjej faturën ose mandatin e pagesës?",
        body: ["Pas një pagese të suksesshme merrni një konfirmim pagese nga faqja e pagesës. Faturën dhe, me kërkesë, një konfirmim pagese i dërgojmë në adresën e e-mailit që kemi në regjistër. Kërkojini mbështetjes nëse ju nevojitet një kopje."],
      },
      {
        id: "complaint",
        title: "Ankesat dhe përshkallëzimi",
        body: [
          `Nëse nuk jeni të kënaqur me trajtimin e kërkesës suaj, përgjigjuni mesazhit tonë duke kërkuar përshkallëzim — ankesa juaj do të shqyrtohet nga drejtimi i ${C.legalName} dhe do të marrë përgjigje brenda 10 ditëve pune. Ruani gjithmonë të drejtën t'i drejtoheni lëshuesit të kartës ose autoriteteve kompetente.`,
        ],
      },
    ],
  },
});
